/**
 * Deterministic letter + fill for bot / synthetic placeholders.
 * Must stay in sync with backend `controllers/trader/leaderboard-bots.js` (public profile, trader boards).
 */

const AVATAR_COLORS = [
  "#E0FFFF",
  "#F0F8FF",
  "#F5FFFA",
  "#FAEBD7",
  "#FFF0F5",
  "#FFFFF0",
  "#FDF5E6",
  "#FFFAF0",
  "#FAFAD2",
  "#FFDAB9",
  "#FFC0CB",
  "#F0E68C",
  "#E6E6FA",
  "#D8BFD8",
  "#ADD8E6",
  "#90EE90",
  "#B0E0E6",
  "#C0C0C0",
  "#D3D3D3",
  "#F5F5DC",
];

/** @param {string|null|undefined} username */
export function getAvatarColor(username) {
  if (!username) return AVATAR_COLORS[0];
  let hash = 0;
  for (let i = 0; i < username.length; i++) {
    hash = username.charCodeAt(i) + ((hash << 5) - hash);
  }
  const colorIndex = Math.abs(hash) % AVATAR_COLORS.length;
  return AVATAR_COLORS[colorIndex];
}

/** @param {string|null|undefined} username */
export function getFirstLetter(username) {
  if (!username) return "?";
  const cleanName = String(username).replace(/_/g, " ").trim();
  return cleanName.charAt(0).toUpperCase();
}

/**
 * Chakra bold caps for bot / synthetic letter tiles (in-play, leaderboard, profile hero).
 * Match Tailwind `font-chakra font-bold` + tracking.
 */
export const BOT_LETTER_AVATAR_FONT_CLASS =
  "font-chakra font-bold uppercase leading-none tracking-normal";

/**
 * Background + text for bot/synthetic letter-only tiles: API `avatar_color` when set, else {@link getAvatarColor} from a display name.
 * @param {null|undefined|{ avatar_color?: string|null, avatarColor?: string|null, name?: string|null, player_name?: string|null, username?: string|null }} row
 * @returns {{ backgroundColor: string, color: string }}
 */
export function getBotLetterAvatarTileStyle(row) {
  if (row == null || typeof row !== "object") {
    return { backgroundColor: getAvatarColor(""), color: "#1B062F" };
  }
  const fromApi = row.avatar_color ?? row.avatarColor;
  if (typeof fromApi === "string" && fromApi.trim() !== "") {
    return { backgroundColor: fromApi.trim(), color: "#1B062F" };
  }
  const label = [row.name, row.player_name, row.username].find((s) => s != null && String(s).trim() !== "");
  const key = label != null ? String(label).trim() : "";
  return { backgroundColor: key ? getAvatarColor(key) : getAvatarColor(""), color: "#1B062F" };
}
